import { TDdpMediaType } from "@/shared/types";
import { HTMLAttributes } from "react";

export function SingleImg(props: { image: TDdpMediaType } & HTMLAttributes<HTMLImageElement>) {
    const { image, ...rest } = props
    if (!image) return <div {...rest} style={{ width: '100%', height: '0' }}></div>;
    return (
        <img src={image.url} alt={image.title}  {...rest} />
    )
}